import API from '@/api'
import router from '@/router'

export const moduleName = 'managersManager'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_LOAD_USERS: 'ACTION_LOAD_USERS',
  ACTION_EDIT_USER: 'ACTION_EDIT_USER',
  ACTION_DELETE_USER: 'ACTION_DELETE_USER',
  ACTION_JOIN_TO_USER_MANAGER: 'ACTION_JOIN_TO_USER_MANAGER',
  ACTION_CHANGE_PASSWORD: 'ACTION_CHANGE_PASSWORD',
  ACTION_GET_HISTORY: 'ACTION_GET_HISTORY',
  ACTION_LOAD_MORE_HISTORY: 'ACTION_LOAD_MORE_HISTORY'
}

export const getterTypes = {
  GETTER_USERS: 'GETTER_USERS',
  GETTER_USERS_COUNT: 'GETTER_USERS_COUNT',
  GETTER_HISTORY: 'GETTER_HISTORY',
  GETTER_HISTORY_COUNT: 'GETTER_HISTORY_COUNT',
   GETTER_PAGE_RELOAD: "GETTER_PAGE_RELOAD"
}

export const mutationTypes = {
  SET_USERS_DATA: 'SET_USERS_DATA',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
  MUTATION_ADD_USER: 'MUTATION_ADD_USER',
  MUTATION_UPDATE_USER_CAR: 'MUTATION_UPDATE_USER_CAR',
  MUTATION_SET_HISTORY: 'MUTATION_SET_HISTORY',
  MUTATION_ADD_HISTORY: 'MUTATION_ADD_HISTORY',
  MUTATION_SET_PAGE_RELOAD: 'MUTATION_SET_PAGE_RELOAD'
}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    users: [],
    usersCount: 0,
    history: [],
    historyCount: 0,
    isPageReload: false
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit }) {
      const onUpdateUser = ({ value }) => {
        commit(mutationTypes.UPDATE_USER, value.user)
      }

      const onDeleteUser = ({ value }) => {
        commit(mutationTypes.DELETE_USER, value)
      }

      const onAddUser = ({ value }) => {
        commit(mutationTypes.MUTATION_ADD_USER, value.user)
      }

      API.managersManager.wsListeners[API.managersManager.wsEvents.USER_MANAGER_DELETE_USER](onDeleteUser)
      API.managersManager.wsListeners[API.managersManager.wsEvents.USER_MANAGER_UPDATE_USER](onUpdateUser)
      API.managersManager.wsListeners[API.managersManager.wsEvents.USER_MANAGER_ADD_USER](onAddUser)
    },

    [actionTypes.ACTION_JOIN_TO_USER_MANAGER] ({ commit }) {
      API.managersManager.wsActions.ACTION_JOIN_TO_USER_MANAGER()
    },

    [actionTypes.ACTION_DELETE_USER] ({ commit }, payload) {
      API.managersManager.wsActions.ACTION_DELETE_USER(payload)
    },

    async [actionTypes.ACTION_LOAD_USERS] ({ commit }, payload) {
      const response = await API.managersManager.loadManagers(payload)
      const { users, count } = response.data
      commit(mutationTypes.SET_USERS_DATA, [users, count])
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, false)

    },

    async [actionTypes.ACTION_CHANGE_PASSWORD] ({ commit }, payload) {
      await API.managersManager.changePassword(payload)
    },

    async [actionTypes.ACTION_GET_HISTORY] ({ commit }, payload) {
      const response = await API.managersManager.loadHistory(payload)
      const { cars, carsCount } = response.data
      commit(mutationTypes.MUTATION_SET_HISTORY, [cars, carsCount])
    },

    async [actionTypes.ACTION_LOAD_MORE_HISTORY]({ commit }, payload) {
      const response = await API.managersManager.loadHistory(payload)
      const { cars } = response.data
      commit(mutationTypes.MUTATION_ADD_HISTORY, cars)
    }
  },

  mutations: {
    [mutationTypes.SET_USERS_DATA] (state, [users, usersCount]) {
      state.users = users
      state.usersCount = usersCount
    },

    [mutationTypes.UPDATE_USER] (state, user) {
      const userIndex = state.users.findIndex(u => u.id === user.id)
      if (userIndex >= 0) {
        state.users.splice(userIndex, 1, {
          ...state.users[userIndex],
          ...user
        })
      }
    },

    [mutationTypes.DELETE_USER] (state, { deletedUsers, appendedUsers, usersCount }) {
      if (Array.isArray(deletedUsers) && Array.isArray(appendedUsers)) {
        deletedUsers.forEach(deletedUser => {
          const userIndex = state.users.findIndex(u => u.id === deletedUser.id)
          if (userIndex >= 0) {
            state.users.splice(userIndex, 1)
          }
        })

        state.users.push(...appendedUsers)
        state.usersCount = usersCount
      }
    },

    [mutationTypes.MUTATION_ADD_USER] (state, user) {
      if (state.users.some(u => u.id === user.id)) return
      const maxRows = Number(router.currentRoute.query.take) || 10

      state.users.unshift(user)
      if (state.users.length > maxRows) {
        state.users.pop()
      }
      state.usersCount++
    },

    [mutationTypes.MUTATION_SET_HISTORY](state, [cars, count]) {
      state.history = cars
      state.historyCount = count
    },

    [mutationTypes.MUTATION_ADD_HISTORY](state, cars) {
      state.history.push(...cars)
    }
  },

  getters: {
    [getterTypes.GETTER_USERS]: (state) => state.users,
    [getterTypes.GETTER_USERS_COUNT]: (state) => state.usersCount,
    [getterTypes.GETTER_HISTORY]: (state) => state.history,
    [getterTypes.GETTER_HISTORY_COUNT]: (state) => state.historyCount,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,

  }
}
